import { isMobile as isMobileUA } from 'react-device-detect';

// gloss
export const MOBILE_HOME_BREAKPOINT = 768;

// gloss
export const isMobileViewport = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < MOBILE_HOME_BREAKPOINT || isMobileUA;
};
